export default __webpack_public_path__ + "static/media/7_Francesc Gonzalez_179x177.23618a0a.webp";